/** ***
------------------------------------------------------------------------

------------------------------------------------------------------------


** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const networkRestrictionsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Progression Link',
        display: 'link',
        linkLabel: {
          labelName: 'linkLabel'
        },
        label: 'Progression',
        'min-width': 150,
        sortable: true,
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'parentTrailHash'
        },
        name: 'parentTrailHash'
      },
      {
        datatype: 'string',
        label: 'Hostname',
        description: 'Hostname',
        sortable: true,
        'min-width': 150,
        name: 'hostname'
      },
      {
        datatype: 'string',
        label: 'IP Address',
        description: 'IP Address',
        sortable: true,
        name: 'ip',
        'min-width': 150
      },
      {
        datatype: 'string',
        label: 'Port',
        description: 'Port',
        sortable: true,
        name: 'port',
        'min-width': 100
      },
      {
        datatype: 'string',
        label: 'Type',
        description: 'Type',
        sortable: true,
        name: 'type',
        'min-width': 200
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Created Time',
        label: 'Created Time',
        name: 'timestamp',
        sortable: true,
        'min-width': 180
      },
      {
        datatype: 'string',
        label: 'Status',
        description: 'Status',
        sortable: true,
        display: 'colorTag',
        name: 'status',
        'min-width': 150,
        displayKey: [
          {
            key: 'on',
            display: 'Blocked',
            color: '#f0f9eb;',
            textColor: '#67c23a'
          },
          {
            key: 'off',
            display: 'Unblocked',
            color: '#f4f4f4',
            textColor: '#666666'
          }
        ]
      }
    ]
  }
}

export { networkRestrictionsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/response_actions/network-restrictions-meta.js